export default __webpack_public_path__ + "static/media/Audio-Number-14.96232d10.mp3";